import map from 'ramda/src/map'
import addIndex from 'ramda/src/addIndex'

export const mappedIndex = addIndex(map)
export const objToNumber = map(parseFloat)
export const stringToBoolean = s => s === 'true' || s === true



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/general.js